import React from 'react';
import { styled } from '@mui/material';
import { Colors } from 'library';

interface RTextInputProps {
    value: string;
    onChange: (value: string) => void;
    placeholder?: string;
    disabled?: boolean;
    fullWidth?: boolean;
    color?: 'white' | 'default';
}

export function RTextInput({ value, onChange, placeholder, disabled, fullWidth, color = 'default' }: RTextInputProps) {
    return (
        <StyledInput
            type="text"
            value={value}
            onChange={(e) => onChange(e.target.value)}
            placeholder={placeholder}
            disabled={disabled}
            fullWidth={fullWidth}
            color={color}
        />
    );
}

const StyledInput = styled('input')<{ fullWidth?: boolean; color?: 'white' | 'default' }>(({ fullWidth, color }) => ({
    width: fullWidth ? '100%' : 'auto',
    padding: '8px 10px',
    fontSize: 14,
    color: Colors.darkNavy,
    backgroundColor: color === 'white' ? Colors.white : Colors.faintGrey,
    border: `1px solid ${Colors.lightGrey}`,
    borderRadius: 10,
    outline: 'none',
    boxSizing: 'border-box',
    '&:focus': {
        borderColor: Colors.mediumGrey,
    },
    '&:disabled': {
        backgroundColor: Colors.fill,
        color: Colors.mediumGrey,
    },
    '&::placeholder': {
        color: Colors.lightGrey,
    },
}));
